import React from 'react';
import { cn } from '../../../lib/utils';

export interface TaskyAuthLayoutProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  logo?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}

export const TaskyAuthLayout: React.FC<TaskyAuthLayoutProps> = ({
  title,
  description,
  logo,
  footer,
  className,
  children,
}) => (
  <div className={cn('min-h-screen flex items-center justify-center bg-warm-bg p-4', className)}>
    <div className="w-full max-w-md">
      {logo && <div className="mb-6 flex justify-center">{logo}</div>}
      <div className="bg-white rounded-tasky-lg shadow-card border border-warm-border p-8">
        {title && (
          <div className="mb-6 text-center">
            <h1 className="text-2xl font-bold text-dark">{title}</h1>
            {description && <p className="text-sm text-gray-500 mt-1">{description}</p>}
          </div>
        )}
        {children}
      </div>
      {footer && <div className="mt-6 text-center text-sm text-gray-500">{footer}</div>}
    </div>
  </div>
);
